module.exports = __webpack_public_path__ + "img/lyndus_logo.a6f6bca3.png";